import { FC, useState, useEffect } from "react";
import { TextDecoder } from "../../shared/text-effects/TextDecoder";

export const DEBOUNCE_DELAY_MS = 1500;

export const DebouncedName: FC<{ text: string }> = ({ text }) => {
  const [displayText, setDisplayText] = useState<string>("");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDisplayText(text);
    }, DEBOUNCE_DELAY_MS);

    return () => clearTimeout(timeoutId);
  }, [text]);

  if (!displayText) {
    return null;
  }

  return (
    <div className="w-full text-white mb-4 text-[1.25rem]/[1.625rem] font-medium">
      <TextDecoder
        className=""
        delay={0}
        duration={500}
        animationType={"in"}
        text={displayText}
      />
    </div>
  );
};
